import { useState } from 'react'
import { Icon } from '../common/Icons/Icon'
import { SocialShareModal } from './SocialShareModal'
import { isMobile } from 'react-device-detect'

export const ShareButton = ({
  shareUrl,
  isFloating,
  position,
} : {
  shareUrl?: string
  isFloating?: boolean
  position?: {
    top?: string
    bottom?: string
    left?: string
    right?: string
  }
}) => {
  const [isSocialMediaModalOpen, setIsSocialMediaModalOpen] = useState(false)

	const onShare = () => {
		if (navigator.share && isMobile) {
			navigator
				.share({
					title: document.title,
					url: window.location.href,
				})
				.then(() => {
          // TBD what to do when share successfully
          console.log('Shared Successfully');
				})
				.catch(console.error)
		} else {
      setIsSocialMediaModalOpen(true)
    }
	}

  return (
    <>
      <button 
        onClick={onShare} 
        className='osirus-share-button'
        style={{
          zIndex: isFloating ? 1070 : undefined,
          position: isFloating ? 'fixed' : undefined,
          top: (isFloating && position?.top) ? position.top : undefined,
          bottom: (isFloating && position?.bottom) ? position.bottom : undefined,
          left: (isFloating && position?.left) ? position.left : undefined,
          right: (isFloating && position?.right) ? position.right : undefined,
        }}
      >
        <Icon iconName='share-nodes' />
      </button>
      {isSocialMediaModalOpen && (
        <SocialShareModal
          shareUrl={shareUrl}
          onClose={() => setIsSocialMediaModalOpen(false)}
        />
      )}
    </>
  )
}
